import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

const de = (v) => (v == null ? "—" : v.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
const tone = (v) => (v == null ? "text-slate-400" : v >= 4 ? "text-emerald-700" : v >= 3 ? "text-amber-600" : "text-red-600");

function CoachRow({ c, questions }) {
  const [open, setOpen] = useState(false);
  const scored = questions.map((q, i) => ({ ...q, n: i + 1, avg: c.avg_per_question[q.id] })).filter((q) => q.avg != null);
  const best = scored.length ? scored.reduce((a, b) => (b.avg > a.avg ? b : a)) : null;
  const weak = scored.length ? scored.reduce((a, b) => (b.avg < a.avg ? b : a)) : null;
  return (
    <>
      <tr className="border-t border-slate-100 hover:bg-slate-50 cursor-pointer" onClick={() => setOpen(!open)} data-testid={`coach-fb-row-${c.coach_id}`}>
        <td className="px-4 py-3 text-sm text-slate-900 flex items-center gap-1.5">
          {open ? <ChevronDown size={13} /> : <ChevronRight size={13} />} {c.name}
        </td>
        <td className="px-4 py-3 text-xs font-mono text-slate-600">{c.total_submitted} / {c.total_sent}</td>
        <td className="px-4 py-3 text-xs font-mono text-slate-600">{c.response_rate.toLocaleString("de-DE")} %</td>
        <td className={`px-4 py-3 text-sm font-mono font-medium ${tone(c.overall_avg)}`} data-testid={`coach-fb-avg-${c.coach_id}`}>{de(c.overall_avg)}</td>
        <td className="px-4 py-3 text-xs text-slate-500 hidden md:table-cell">{weak && weak.avg < 4 ? `Frage ${weak.n} (${de(weak.avg)})` : "—"}</td>
      </tr>
      {open && (
        <tr className="bg-slate-50" data-testid={`coach-fb-detail-${c.coach_id}`}>
          <td colSpan={5} className="px-4 py-4">
            {best && <div className="text-xs text-emerald-700 mb-1">Stärke: {best.n}. {best.text} ({de(best.avg)})</div>}
            {weak && weak.avg < 4 && weak.id !== best?.id && <div className="text-xs text-red-600 mb-3">Schulungsbedarf: {weak.n}. {weak.text} ({de(weak.avg)})</div>}
            <div className="space-y-1.5">
              {questions.map((q, i) => (
                <div key={q.id} className="flex items-center gap-3 text-xs">
                  <span className="flex-1 text-slate-700">{i + 1}. {q.text}</span>
                  <div className="w-24 h-1.5 bg-slate-200 shrink-0"><div className="h-full bg-slate-900" style={{ width: `${((c.avg_per_question[q.id] || 0) / 5) * 100}%` }} /></div>
                  <span className={`w-10 text-right font-mono ${tone(c.avg_per_question[q.id])}`}>{de(c.avg_per_question[q.id])}</span>
                </div>
              ))}
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

export default function CoachFeedbackTable({ coaches, questions }) {
  if (!coaches?.length) return null;
  return (
    <div className="border border-slate-200 bg-white mb-6 overflow-x-auto" data-testid="coach-feedback-table">
      <div className="px-4 py-3 border-b border-slate-100 text-[10px] font-bold uppercase tracking-overline text-slate-500">Ergebnisse je Coach</div>
      <table className="w-full text-left">
        <thead>
          <tr className="text-[10px] uppercase tracking-overline text-slate-500">
            <th className="px-4 py-2 font-bold">Coach</th><th className="px-4 py-2 font-bold">Antworten</th>
            <th className="px-4 py-2 font-bold">Rücklauf</th><th className="px-4 py-2 font-bold whitespace-nowrap">Ø (1–5)</th>
            <th className="px-4 py-2 font-bold hidden md:table-cell">Schwächste Frage</th>
          </tr>
        </thead>
        <tbody>{coaches.map((c) => <CoachRow key={c.coach_id} c={c} questions={questions} />)}</tbody>
      </table>
    </div>
  );
}
